import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { User } from "../models/User";
import { findIndex } from 'lodash'
import { Organization } from "../models/Organization";
import { Group } from "../models/Group";
import { ScorecardAcknowledgment } from "../models/ScorecardAcknowledgment";

interface AppState {
	isLoading: boolean,
	currentUser: User|undefined,
	groupUsers: GroupUsers
	userGroupMembership: UserGroupMembership,
	currentOrganization: Organization|undefined,
	
}

interface GroupUsers {
	groupId: number,
	groupUsers: User[] | undefined
}

interface UserGroupMembership {
	userId: number,
	groups: Group[] | undefined
}

const initialState: AppState ={
	isLoading: false,
	currentUser: undefined,
	groupUsers: {} as GroupUsers,
	userGroupMembership: {} as UserGroupMembership,
	currentOrganization: undefined,
	
}

export const appStateSlice = createSlice({
	name:'appState',
	initialState,
	reducers:{
		setGroup:(state, action:PayloadAction<Group>) => {
			const groupId = action.payload?.groupID;
			if (state.currentUser?.userID) {
				const myGroups = state.userGroupMembership[state.currentUser.userID]?.groupMembership
				if (myGroups) {
					const index = findIndex(myGroups, group => group.id === groupId);
					if (index !== -1) {
						myGroups[index] = action.payload
					}
				}
			}
		},

		setUsers:(state, action: PayloadAction<GroupUsers>) => {
			if (action.payload){
				if (action.payload.groupId !== -1) {
					state.groupUsers[action.payload.groupId] = action.payload.groupUsers
				}
			}
		},

		setUserGroup:(state, action: PayloadAction<UserGroupMembership>) => {
			if (action.payload){
				state.userGroupMembership[action.payload.userId] = action.payload.groups
			}
		},

		setLoading:(state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload
		},

		setCurrentUser:(state, action: PayloadAction<User>) => {
			state.currentUser = action.payload
		},
		setCurrentOrganization:(state, action: PayloadAction<Organization>) => {
			state.currentOrganization = action.payload;
		},
		clearAppState:(state)=> {
			state.isLoading = false
			state.currentUser = undefined
			state.groupUsers = {} as GroupUsers
			state.userGroupMembership = {} as UserGroupMembership
			state.currentOrganization = undefined
		},

		updateAcknowledgmentDate:(state, action: PayloadAction<ScorecardAcknowledgment>)=> {
			if (state.currentUser) {
				if (state.currentUser.scorecard) {

					const currentScorecardAcknowledgment = state.currentUser.scorecard.acknowledgment;

					if (currentScorecardAcknowledgment && currentScorecardAcknowledgment.acknowledgmentID === action.payload.acknowledgmentID) {
						state.currentUser.scorecard.acknowledgment = action.payload;
					}		
				}
			}
		},
	}
});

export const { 
	setCurrentUser, 
	setCurrentOrganization, 
	setGroup, 
	setUsers, 
	setUserGroup,  
	clearAppState,
	updateAcknowledgmentDate } = appStateSlice.actions

export default appStateSlice.reducer;